import React from 'react';
import { CASE_STATUS_COMPLETED } from './CaseConstants';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
import PropTypes from 'prop-types';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/completed' },
  { label: 'Completed', to: '/user/case/completed' },
];
const CompletedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.completed_case_list_title}
          caseStatus={CASE_STATUS_COMPLETED}
          breadCrumbItems={BREAD_CRUMBS}
          hideFooter
          showHasFilter = {true}
          // showProStatusFilter = {true}
        />
      </div>
    </div>
  );
};
CaseList.propTypes = {
  title: PropTypes.string.isRequired,
  caseStatus: PropTypes.string.isRequired,
  breadCrumbItems: PropTypes.array,
  hideFooter: PropTypes.bool,
  showHasFilter: PropTypes.bool,
  // showProStatusFilter: PropTypes.bool,
  
};

export default CompletedCases;
